var ___EXPOSE_LOADER_IMPORT___ = require("-!../../babel-loader/lib/index.js??ruleSet[1].rules[2]!./color-thief.min.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["ColorThief"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["ColorThief"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
